var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:([{width: _vm.width, height: _vm.height}, _vm.componentStyle]),attrs:{"id":"postcode"}},[_vm._v("\n    "+_vm._s(this.dataError && this.errorMessage)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }